import { makeStyles } from "@mui/styles";
import theme from "assets/theme";

const useStyles = makeStyles(() => ({
  modalContainer: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 9999,
  },
  popupContent: {
    height: "80%",
    width: "80%",
    backgroundColor: "#fff",
    color: "black",
    padding: theme.spacing(4),
    borderRadius: "8px",
    boxShadow: theme.shadows[3],
    display: "flex",
    flexDirection: "column",
    overflow: "auto",
    [theme.breakpoints.down("sm")]: {
      height: "90%",
      width: "90%",
    },
  },
  header: {
    marginBottom: theme.spacing(2),
  },
  paymentDetails: {
    display: "flex",
    justifyContent: "space-between",
    gap: theme.spacing(4),
    flexDirection: "row",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
    },
  },
  qrCodeContainer: {
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    alignItems: "center",
    margin: "0 auto",
  },
  qrCodeImage: {
    height: "300px",
    width: "auto",
    marginBottom: theme.spacing(2),
  },
  paymentMethods: {
    marginBottom: theme.spacing(5),
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
    justifyContent: "center",
    gap: theme.spacing(2),
  },
  paymentMethodsMobile: {
    width: "90%",
    marginBottom: theme.spacing(5),
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
    justifyContent: "center",
    gap: theme.spacing(2),
  },
  paymentIcon: {
    height: "40px",
  },
  paymentIconMobile: {
    height: "30px",
  },
  upiInfoBox: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: theme.spacing(2),
    boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px",
    padding: theme.spacing(1),
    borderRadius: "10px",
    width: "80%",
  },
  upiIdMobile: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: theme.spacing(2),
    boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px",
    padding: theme.spacing(1),
    borderRadius: "10px",
    width: "100%",
  },
  upiText: {
    fontSize: "18px",
    textAlign: "center",
  },
  formBox: {
    width: "45%",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  },
  input: {},
  uploadButton: {
    margin: "16px 0",
  },
  submitButton: {
    // width: "45%",
  },
  screenshotText: {
    marginBottom: theme.spacing(2),
  },
}));

export default useStyles;
